<template>

  <iframe class="" :src="url"></iframe>

</template>

<script>
  import discountCardLog from '../page/discountCard/discountCardLog';

  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'iframe_url': '',
      'param': ''
    },
    watch: {
      isShow: {

        immediate: true,
        handler: function (newData, oldData) {
          console.log(this.iframe_url);
          if(newData){
            this.url = this.iframe_url + this.param +'&city_tag='+localStorage.getItem('city_tag')
          }else{
            this.url = '';
          }

        }

      }

    },
    data() {
      return {


        url: this.iframe_url + this.param,


      };
    },
    created() {
      _this = this;

    },
    methods: {




      closeDialog() {
        _this.show = false;
      },


    }
  };
</script>

<style scoped>
  iframe {
    width: 100%;
    border: medium none;
  }
</style>
